export default {
  name: 'machineChecklist',
  miniSave: false,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction.methodRequest(
      `/register/machine/checklist/${data.machineid}`,
      'POST',
      data.questions
    )
  },
  restoreSave: (ctx) => {
    const data = ctx.saveObj.data
    ctx.router.push({
      name: `machines-machineid-checklist-edit`,
      params: { machineid: data.machineid },
      query: { sid: ctx.saveId },
    })
  },
}
